import React from "react";
import { Filter } from "lucide-react";

const FILTERS = [
  { k: "all", label: "Todas" },
  { k: "today", label: "Hoy" },
  { k: "upcoming", label: "Próximas" },
  { k: "pending", label: "Pendientes" },
  { k: "change-requested", label: "Cambio solicitado" },
  { k: "to-remind", label: "Por recordar" },
];

export default function AppointmentFilters({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <Filter className="h-4 w-4 text-neutral-500" />
      {FILTERS.map((opt) => (
        <button
          key={opt.k}
          data-testid={`appt-filter-${opt.k}`}
          onClick={() => onChange(opt.k)}
          className={
            "px-3 h-9 rounded-full text-sm font-semibold border transition-colors " +
            (value === opt.k
              ? "bg-orange-500 text-white border-orange-500"
              : "bg-white text-neutral-700 border-neutral-200 hover:bg-neutral-50")
          }
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
